/**
 * Created by mslobozeanu on 9/21/2016.
 */

TS.ns('TS.domain.properties.fields');

var baseMapping = TS.domain.properties.ListField.prototype.mapping,
    baseObservables = TS.domain.properties.ListField.prototype.observables;

/**
 * @class TS.domain.properties.fields.SelectionListField
 * @classdesc
 * @extends TS.domain.properties.ListField
 * @ignore
 */
var SelectionListField = TS.domain.properties.fields.SelectionListField = new Class(
    /** @lends TS.domain.properties.fields.SelectionListField# */
    {

        Extends: TS.domain.properties.ListField,

        mapping: $.extend({}, baseMapping, {
            ignore: baseMapping.ignore.concat([]),
            copy: baseMapping.copy.concat(['ValueMember', 'ListMember', 'AutoOpen', 'AllowEmptySelection', 'lookupProperty']),
            suppress: baseMapping.suppress.concat(['DisplayPropertyName', 'ValueMember', 'ListMember', 'lookupProperty']),
        }),

        observables: $.extend({}, baseObservables, {
            DisplayPropertyName: undefined,
            SelectedItem: null
        }),

        //selectionProperty

        initialize: function (owner, config) {
            var me = this;
            me.parent(owner, config);
            me.propertyPath = owner.Name + '.Fields.' + me.Name;
            me.AllowEmptySelection = true;
            me.initKendoDataSource();
            //after all is set, create bindings
            config.ClientFilters && me.createClientFiltersBindings(config.ClientFilters);
        },

        DisplayValue: function (value) {
            var me = this,
                owner = me._getOwner();
            if (arguments.length === 0) {
                if (owner && owner.SelectedItem()) {
                    return TS.unwrap(owner.SelectedItem()[me.DisplayPropertyName()]);
                }
                return null;
            }
            if (owner && owner.SelectedItem()) {
                ts.setPropertyValue(owner.SelectedItem(), me.DisplayPropertyName(), value);
            }
        }

    });

TS.domain.properties.SelectionListProperty.mixin(SelectionListField);

TS.domain.properties.ListField.types['selection'] = SelectionListField;